import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedSeccionmarketings,
  addingSeccionmarketings,
  addingSeccionmarketingsFailed,
  editedSeccionmarketings,
  editingSeccionmarketings,
  editingSeccionmarketingsFailed,
  foundSeccionmarketings,
  loadedSeccionmarketings,
  loadingSeccionmarketings,
  loadingSeccionmarketingsFailed,
  removedSeccionmarketing,
  removingSeccionmarketing,
  removingSeccionmarketingFailed,
  searchingSeccionmarketings,
  searchingSeccionmarketingsFailed,
  SeccionmarketingsAction,
  SeccionmarketingsActionTypes,
  softRemovedSeccionmarketings,
  softRemovingSeccionmarketings,
  softRemovingSeccionmarketingsFailed,
} from '../actions/seccionmarketingsActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.SEARCH_SECCIONMARKETINGS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/seccionmarketings/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundSeccionmarketings(response.data, action.keep)),
        startWith(searchingSeccionmarketings()),
        catchError(() => of(searchingSeccionmarketingsFailed()))
      )
    })
  )

const loadSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.LOAD_SECCIONMARKETINGS)),
    switchMap((action) => {
      let url = `${API_URL}/api/seccionmarketings/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedSeccionmarketings(response.data)),
        startWith(loadingSeccionmarketings()),
        catchError(() => of(loadingSeccionmarketingsFailed()))
      )
    })
  )
}

const addSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.ADD_SECCIONMARKETINGS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/seccionmarketings/`, data, config)).pipe(
        map((response) => addedSeccionmarketings(response.data)),
        startWith(addingSeccionmarketings()),
        catchError((err) => of(addingSeccionmarketingsFailed(err.response)))
      )
    })
  )

const removeSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.REMOVE_SECCIONMARKETING)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionmarketings/${action.payload._id}`)).pipe(
        map((response) => removedSeccionmarketing()),
        startWith(removingSeccionmarketing()),
        catchError(() => of(removingSeccionmarketingFailed()))
      )
    )
  )

const softRemoveSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.SOFT_REMOVE_SECCIONMARKETINGS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionmarketings/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedSeccionmarketings(response.data.record)),
        startWith(softRemovingSeccionmarketings()),
        catchError((err) => of(softRemovingSeccionmarketingsFailed(err.response)))
      )
    )
  )

const editSeccionmarketingsEpic: Epic<SeccionmarketingsAction, SeccionmarketingsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionmarketingsActionTypes.EDIT_SECCIONMARKETINGS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/seccionmarketings/${action.payload._id}`, data, config)).pipe(
        map((response) => editedSeccionmarketings(response.data)),
        startWith(editingSeccionmarketings()),
        catchError((err) => of(editingSeccionmarketingsFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchSeccionmarketingsEpic,
  loadSeccionmarketingsEpic,
  addSeccionmarketingsEpic,
  removeSeccionmarketingsEpic,
  softRemoveSeccionmarketingsEpic,
  editSeccionmarketingsEpic
)
